import React, {useEffect, useState} from "react";
import {Button, ConfigProvider, Dropdown, Select, Table,} from "antd";
import {CaseDashboardTableHeaders, CaseDashboardTechnicianTableHeaders,} from "../Constants";
import {useNavigate} from "react-router-dom";
import {PlusOutlined} from "@ant-design/icons";
import "../CaseListingStyles.css";
import AntdButton from "../../../components/form/AntdButton";
import {getWorkforceDashboardData} from "../../../Services/workforce";
import {useDispatch} from "react-redux";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED,} from "../../../store/features/loadingSlice";
import Chart from "react-apexcharts";
import {useDropdowns} from "../../../hooks/useDropdowns";
import {Controller, useForm} from "react-hook-form";
import {CaseListingExcelDownload} from "../CaseListingExcelDownload";
import DashboardCasePopup from "./DashboardCasePopup";

const options = {
    chart: {
        height: 300,
        width: "100%",
        type: "donut",
    },
    fill: {
        colors: ["#e9f5fd", "#6dbae1", "#768fbb"],
    },
    plotOptions: {
        pie: {
            startAngle: -200,
            endAngle: 160,
            donut: {
                labels: {
                    show: true,
                    value: {
                        fontSize: "40",
                        fontWeight: "700",
                        color: "#2f5e8a",
                        offsetY: 0,
                        formatter: function (val) {
                            return val;
                        },
                    },
                    total: {
                        show: true,
                        showAlways: true,
                        color: "#2f5e8a",
                        label: "Total Cases",
                        offsetY: -50,
                    },
                    name: {
                        offsetY: 40,
                    },
                },
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    legend: {
        formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex] + " " + val;
        },
        fontSize: "16",
        fontWeight: "500",
        position: "bottom",
        labels: {
            colors: "#323232",
            useSeriesColors: false,
        },
        markers: {
            strokeColor: "#000",
            fillColors: ["#e9f5fd", "#6dbae1", "#768fbb"],
        },
    },
    responsive: [
        {
            breakpoint: 480,
            options: {
                chart: {
                    width: 100,
                },
                legend: {
                    position: "bottom",
                },
            },
        },
    ],
};

const Header = () => {
    return (
        <>
            <div className="">
                <p className="font-bold">Workforce Management</p>
            </div>
        </>
    );
};

const DashboardContent = () => {
    const dispatch = useDispatch();
    const [
        workforceDashboardTechnicianData,
        setWorkforceDashboardTechnicianData,
    ] = useState({});
    const [workforceDashboardChartData, setWorkforceDashboardChartData] =
        useState({});
    const [workforceDashboardCasesData, setWorkforceDashboardCasesData] =
        useState({});

    useEffect(() => {
        dispatch(SET_IS_API_CALLED("Retrieving Workforce Data"));
        // hardcode the interval type
        getWorkforceDashboardData({intervalTypeId: 6}).then((res) => {
            setWorkforceDashboardTechnicianData(res?.data?.technicianGroups);
            setWorkforceDashboardChartData(res?.data?.chart);
            setWorkforceDashboardCasesData(res?.data?.cases);
        });
        dispatch(SET_IS_API_CALLED_FINISHED());
    }, []);

    return (
        <>
            <div className="grid grid-cols-4 gap-8">
                <div className="flex flex-col pr-8 gap-8">
                    <CaseDashboardContentChart chartData={workforceDashboardChartData}/>
                </div>
                <div className="col-span-3 flex flex-col">
                    {/* table here */}
                    <CaseDashboardContentTableHeader
                        setWorkforceDashboardTechnicianData={
                            setWorkforceDashboardTechnicianData
                        }
                        setWorkforceDashboardChartData={setWorkforceDashboardChartData}
                        setWorkforceDashboardCasesData={setWorkforceDashboardCasesData}
                    />
                    <p className="font-bold py-3">List By Region</p>
                    <CaseDashboardContentTable
                        workforceData={workforceDashboardCasesData}
                    />
                    <br />
                    <CaseDashboardTechnicianContent
                        technicianData={workforceDashboardTechnicianData}
                    />
                </div>
            </div>
        </>
    );
};

const CaseDashboardTechnicianContent = ({technicianData}) => {
    const navigate = useNavigate();
    return (
        <>
            <div>
                <div className="flex justify-between pb-3">
                    <p className="font-bold">List By Team</p>
                    <Button onClick={() => navigate("/wf-technician-listing")}>
                        View By Team
                    </Button>
                </div>
                <CaseDashboardTechnicianTable technicianData={technicianData}/>
            </div>
        </>
    );
};

const CaseDashboardContentTableHeader = ({
                                             setWorkforceDashboardTechnicianData,
                                             setWorkforceDashboardChartData,
                                             setWorkforceDashboardCasesData,
                                         }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {state, getRegionsDropDown, getIntervalDropDown} = useDropdowns();
    const {control, handleSubmit} = useForm();

    useEffect(() => {
        getRegionsDropDown();
        getIntervalDropDown();

    }, []);

    const handleSearchWorkforceManagementData = (data) => {
        dispatch(SET_IS_API_CALLED("Retrieving Dashboard Data"));
        getWorkforceDashboardData({
            region: data?.region,
            intervalTypeId: data?.intervalTypeId
        })
            .then((res) => {
                setWorkforceDashboardTechnicianData(res?.data?.technicianGroups);
                setWorkforceDashboardChartData(res?.data?.chart);
                setWorkforceDashboardCasesData(res?.data?.cases);
            })
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            });
    };

    const handleWorkforceExcelDownload = (data) => {
        dispatch(SET_IS_API_CALLED("Downloading Excel Data"));
        CaseListingExcelDownload({
            intervalTypeId: data?.intervalTypeId
        }).finally(() => {
            dispatch(SET_IS_API_CALLED_FINISHED());
        });
    };

    return (
        <>
            <form>
                <div className="flex justify-between gap-2 pb-4">
                    <div className="basis-2/12">
                        <Controller
                            name={"region"}
                            control={control}
                            render={({field}) => (
                                <Select
                                    allowClear
                                    style={{
                                        width: "100%",
                                        overflowY: "hidden",
                                        overflowX: "ellipsis",
                                        maxWidth: "100%",
                                        height: "100%",
                                    }}
                                    maxTagCount={2}
                                    maxTagTextLength={3}
                                    placeholder="Region"
                                    onChange={field.onChange}
                                    value={field.value}
                                    options={state.regionsDropDown?.map((val) => {
                                        return {
                                            value: val?.name,
                                            label: val?.name,
                                        };
                                    })}
                                    className={"max-w-full max-h-full w-100"}
                                />
                            )}
                        />
                    </div>
                    <div className="basis-2/12">
                        <Controller
                            name={"intervalTypeId"}
                            control={control}
                            defaultValue={6}
                            render={({field}) => (
                                <Select
                                    allowClear
                                    style={{
                                        width: "100%",
                                        overflowY: "hidden",
                                        overflowX: "ellipsis",
                                        maxWidth: "100%",
                                        height: "100%",
                                    }}
                                    maxTagCount={2}
                                    maxTagTextLength={3}
                                    placeholder="Interval"
                                    onChange={field.onChange}
                                    value={field.value}
                                    options={state.intervalTypesDropDown?.map((val) => {
                                        return {
                                            value: val?.id,
                                            label: val?.name,
                                        };
                                    })}
                                    className={"max-w-full max-h-full w-100"}
                                />
                            )}
                        />
                    </div>
                    <div className="basis-2/12">
                        <Button
                            className="w-full"
                            onClick={handleSubmit(handleSearchWorkforceManagementData)}
                        >
                            Generate
                        </Button>
                    </div>
                    <div className={"basis-2/12"}></div>
                    <div className="basis-5/12 grid grid-cols-3 gap-2">
                        <button
                            type={"button"}
                            className="max-w-fit justify-self-end"
                            onClick={handleSubmit(handleWorkforceExcelDownload)}
                        >
                            <img
                                src={"/assets/icon-excel.svg"}
                                className=" cursor-pointer"
                                width={30} // is it a good idea to hardcode these values?
                                height={30}
                                alt=""
                            />
                        </button>
                        <Button onClick={() => navigate("/wf-case-listing")}>
                            View All Cases
                        </Button>
                        <AntdButton
                            onClick={() => navigate("/wf-create-case")}
                            icon={<PlusOutlined/>}
                        >
                            Create Case
                        </AntdButton>
                    </div>
                </div>
            </form>
        </>
    );
};

const CaseDashboardContentTable = ({workforceData}) => {
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: workforceData?.pageIndex,
            pageSize: 100, // set to as many as possible
            total: workforceData?.totalItems,
        },
    });

    return (
        <Table
            className="table-striped-rows"
            dataSource={workforceData?.items}
            //   rowSelection={{ type: "checkbox", ...rowSelection }}
            columns={CaseDashboardTableHeaders}
            pagination={tableParams}
            showSizeChanger={true}
        ></Table>
    );
};

const CaseDashboardContentChart = ({chartData}) => {
    return (
        <>
            <div className="flex flex-col bg-white">
                <div className="flex place-content-between px-3 pt-3">
                    <p className="font-bold ">Case Dashboard</p>
                    <Dropdown
                        trigger={["click"]}
                        placement="bottomLeft"
                        arrow
                        dropdownRender={() => (
                            <div>
                                <DashboardCasePopup/>
                                {/*<TransmissionStatus /> */}
                            </div>
                        )}
                    >
                        <img
                            src={"/assets/icon-info.svg"}
                            alt="Info"
                            width={25}
                            className=" cursor-pointer"
                        />
                    </Dropdown>
                </div>
                <Chart
                    type="donut"
                    options={{...options, labels: chartData?.labels?.length >= 1 ? chartData?.labels : ["", ""]}}
                    series={chartData?.series?.length >= 1 ? chartData?.series : [0, 0]} //chartData?.series?.length > 0 ||
                    height={350}
                    className={"mt-10 h-full max-h-[350]"}
                />
            </div>
        </>
    );
};

const CaseDashboardTechnicianTable = ({technicianData}) => {
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: technicianData?.pageIndex,
            pageSize: 3,
            total: technicianData?.totalItems,
        },
    });

    return (
        <Table
            className="table-striped-rows"
            dataSource={technicianData?.items ?? []}
            //   rowSelection={{ type: "checkbox", ...rowSelection }}
            columns={CaseDashboardTechnicianTableHeaders}
            pagination={{total: technicianData?.totalPages}}
            // showSizeChanger={true}
        ></Table>
    );
};

const WorkforceDashboardPage = () => {
    return (
        <>
            <div className="p-4">
                <div className="flex flex-col gap-7">
                    <Header/>
                    <ConfigProvider
                        theme={{
                            components: {
                                Button: {
                                    defaultBg: "#6DBAE1",
                                    defaultColor: "#FFFFFF",
                                    defaultHoverBg: "#FFFFFF",
                                    defaultHoverColor: "#6DBAE1",
                                    defaultHoverBorderColor: "#6DBAE1",
                                },
                                Table: {
                                    /* here is your component tokens */
                                    headerBorderRadius: 0,
                                    headerBg: "#2F5E8A",
                                    headerColor: "#F5F5F5",
                                    headerSortActiveBg: "#2F5E8A",
                                    headerSortHoverBg: "#2F5E8A",
                                    fixedHeaderSortActiveBg: "#2F5E8A",
                                },
                            },
                        }}
                    >
                        <DashboardContent/>
                    </ConfigProvider>
                </div>
            </div>
        </>
    );
};

export default WorkforceDashboardPage;
